module.exports = __webpack_public_path__ + "static/media/email-illustration.0815df49.svg";